﻿import { getMilestoneNotificationAdGroupIds } from "@/helpers";

export const isUserNotificationUser = (schedules, groupIds) => {
  if (!schedules?.length || !groupIds?.length) return;

  const totalAzAdGroupsIds = schedules
    .map((schedule) => getMilestoneNotificationAdGroupIds(schedule.milestones))
    .flat();

  return totalAzAdGroupsIds.some((id) => groupIds.includes(id));
};
